import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";
import { documentTypeColor } from "@utils/constants";

const DocumentType = (props) => {
  const { t, type, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === true ? 1 : "0.2"}>
        <ColumnButton
          border={documentTypeColor[type.id]}
          background={documentTypeColor[type.id]}
          marginRight="10px"
        >
          <span>{t(type.name)}</span>
        </ColumnButton>
      </DivBackgroundOpacity>
    </>
  );
};

DocumentType.defaultProps = {
  isActive: true,
};

DocumentType.propTypes = {
  t: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default withTranslation()(DocumentType);
